<template>
    <div class="h5">
        <img class="h5-img" src="../../assets/d-img/h5-dowb.png" alt="h5">
        <div class="h5-btn">
            <template v-if="isWX">
                <wx-open-launch-app
                    id="jump-app"
                    appid="wxcf26e67f34abb5e5"
                    :extinfo="extinfo"
                    style="margin: auto; width: 343px;"
                >
                    <div v-is="'script'" type="text/wxtag-template">
                        <div style="
                            width: 343px;
                            background: #0F50C5 !important;
                            border-radius: 4px;
                            line-height: 50px;
                            margin: auto;
                            color: #fff;
                            font-size: 14px;
                            text-align: center;"
                        >下载或跳转App</div>
                    </div>
                </wx-open-launch-app>
            </template>
            <van-button v-else type="primary" @click="jumpApp"  style="width: 343px; margin: auto;" color="#0F50C5" size="large" block>下载或跳转App</van-button>
        </div>
    </div>
</template>

<script>
    import { isWeChat } from '@/utils/validate';
    export default {
        name: 'H5Down',
        data() {
            return {
                isWX: isWeChat(),
                appId: 'wxcf26e67f34abb5e5',
                extinfo: ''
            }
        },
        mounted() {
            if(isWeChat()) {
                let u = navigator.userAgent
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
                let url = isiOS ? 'jxyyService://' : ''
                this.extinfo = url

                this.wxConfiguration()
            }
        },
        methods: {
            // 跳转App  /h5/jump_app
            jumpApp() {
                if(isWeChat()) {
                    this.wxConfiguration()
                    // this.submitDelete()
                    return
                }

                this.$http.post('/h5/jump_app').then(({ data: res }) => {
                    let u = navigator.userAgent
                    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
                    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

                    if (isAndroid) {
                        // window.location.href = res.data.androidLink
                        let _clickTime = new Date().getTime()
                        let _count = 0, intHandle = null
                        let src = 'android://jxyy/splash'
                        window.location.href = src  // 安卓对应的app协议
                        intHandle = setInterval(function(){
                            _count++
                            let elsTime = new Date().getTime() - _clickTime;
                            if (_count >= 100 || elsTime > 3000 ) {
                                clearInterval(intHandle);
                                let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                                if (hidden) {
                                    window.close()
                                } else {
                                    window.location.href = res.data.androidLink
                                }
                            }
                        }, 20)
                    } else if (isiOS) {
                        // window.location.href = res.data.iosLink
                        let _clickTime = +(new Date());
                        let src = 'jxyyService://'
                        window.location.href = src
                        let _count = 0, intHandle = null;
                        intHandle = setInterval(function(){
                            _count++
                            let elsTime =  +(new Date()) - _clickTime
                            if (_count >= 100 || elsTime > 3000 ) {
                                clearInterval(intHandle);
                                let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                                if (hidden) {
                                    setTimeout(window.close, 301)
                                } else {
                                    window.location.href = res.data.iosLink
                                }
                            }
                        }, 20)
                    } else {
                        window.location.href = res.data.androidLink
                    }
                })
            },
            submitDelete() {
                this.$dialog.confirm({
                    message: '请点击页面右上角". . ."选择“在浏览器打开”',
                    confirmButtonColor: "#0F50C5",
                    cancelButtonColor: "#000000"
                });
            },
            wxConfiguration() {
                const url = window.location.href.split('#')[0];
                //url = encodeURIComponent(url);
                let data = {
                    uri: url
                }
                this.$http.post('/h5/jssdk', data).then(({ data: res })  => {
                    if(res.success) {
                        let config = res.data
                        // process.env.NODE_ENV == 'production' ? false :
                        window.wx.config({
                            // debug: process.env.NODE_ENV == 'development' ? true : false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.app_id, // 必填，企业号的唯一标识，此处填写企业号corpid
                            timestamp: Number(config.timestamp), // 必填，生成签名的时间戳
                            nonceStr: config.nonce_str, // 必填，生成签名的随机串
                            timestamp: config.timestamp, // 必填，生成签名的时间戳
                            signature: config.signature, // 必填，签名
                            jsApiList: [], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                            openTagList: ['wx-open-launch-app']
                        })
                        window.wx.ready((res) => {
                            var btn = document.getElementById('jump-app')
                            btn.addEventListener('error', (e) => {
                                if(e.detail.errMsg == 'launch:fail') {
                                  this.submitDelete()
                                }
                            })
                        })
                        window.wx.error((res) =>{
                            this.submitDelete()
                            // this.$toast.fail(e.detail.errMsg);
                        })
                        var btn = document.getElementById('jump-app')
                        btn.addEventListener('launch', () => {
                            console.log('success');
                        });
                        btn.addEventListener('error', (e) => {
                            console.log('fail', e.detail);
                            this.submitDelete()
                        });
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss" src="./index.scss"></style>
